import React from 'react'
import { Input, Grid, Popup } from 'semantic-ui-react'

const { Row, Column } = Grid

const TextField = ({
  after,
  before,
  children,
  className,
  disabled,
  error,
  label,
  onBlur,
  onChange,
  required,
  tooltip,
  type,
  validated,
  value,
}) => (
  <Row className={`field ${className}${required ? ' required' : ''}`}>
    <Column width={4}><span className="field-label">{label}: </span></Column>
    <Column width={8}>
      {before}
      <Input
        disabled={disabled}
        name={name}
        onChange={(e, event) => onChange(event)}
        required={required || undefined}
        type={type}
        value={value}
      >
        <input onBlur={onBlur} />
      </Input>
      {after}
      {!!tooltip &&
        <Popup
          trigger={<i className="daicon daicon-Help tooltip" />}
          content={tooltip}
          position="right center"
        />

      }
    </Column>
    <Column width={4}>
      {!!error &&
        <Popup
          trigger={<i className="daicon daicon-Attention error" />}
          content={error}
          position="right center"
        />
      }

      {validated && !error &&
        <i className="daicon daicon-Checkmark success" />
      }
      {children}
    </Column>
  </Row>
)

TextField.defaultProps = {
  after: null,
  before: null,
  children: null,
  className: '',
  disabled: false,
  error: '',
  onBlur: () => {},
  required: false,
  tooltip: '',
  type: 'text',
  validated: false,
}

TextField.propTypes = {
  after: React.PropTypes.any,
  before: React.PropTypes.any,
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  error: React.PropTypes.string,
  label: React.PropTypes.string.isRequired,
  name: React.PropTypes.string.isRequired,
  onBlur: React.PropTypes.func,
  onChange: React.PropTypes.func.isRequired,
  required: React.PropTypes.bool,
  tooltip: React.PropTypes.string,
  type: React.PropTypes.string,
  validated: React.PropTypes.bool,
  value: React.PropTypes.string.isRequired,
}

export default TextField



// WEBPACK FOOTER //
// ./src/browser/components/fields/Text.js